/**
 *
 * PollOverview
 *
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Text, { TEXT_SIZE, TEXT_COLOR, TEXT_WEIGHT } from '@components/Text';
import {
  TitleContainer,
  DescriptionArea,
  SkipPollStatusContainer,
  StyledSkipPollEnabledIcon,
  StyledSkipPollDisabledIcon,
} from './styles';
import {withTranslation} from "react-i18next";
import {compose} from "redux";
import SurveyJsPollRuntime from '../Client/SurveyJsPollRuntime';

class PollOverview extends PureComponent {
  render() {
    const {resource: { description, surveySchema, skipPollEnabled }, t} = this.props;
    return (
      <div>
        <DescriptionArea>
          <TitleContainer>
            <Text
              size={TEXT_SIZE.H4}
              textColor={TEXT_COLOR.DARK_BLUE}
              weight={TEXT_WEIGHT.BOLD}
            >
              {t('Common.UI.description')}
            </Text>
          </TitleContainer>
          <Text size={TEXT_SIZE.T4} textColor={TEXT_COLOR.DARK_BLUE}>
            {description}
          </Text>
        </DescriptionArea>
        <SkipPollStatusContainer>
          {skipPollEnabled ? <StyledSkipPollEnabledIcon /> : <StyledSkipPollDisabledIcon />}
          <Text size={TEXT_SIZE.T3} textColor={TEXT_COLOR.DARK_BLUE}>
            {t(skipPollEnabled ? 'PollBuilder.skipPollEnabled' : 'PollBuilder.skipPollDisabled')}
          </Text>
        </SkipPollStatusContainer>
        <SurveyJsPollRuntime schema={surveySchema} readOnly />
      </div>
    );
  }
}

PollOverview.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default compose(withTranslation())(PollOverview);
